<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>ComfyUI</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, user-scalable=no"
    />
    <link rel="stylesheet" type="text/css" href="materialdesignicons.min.css" />

    <!-- Fullscreen mode on mobile browsers -->
    <meta name="mobile-web-app-capable" content="yes" />
    <!-- Status bar style (eg. black or transparent) -->
    <meta name="apple-mobile-web-app-status-bar-style" content="black" />
    <style>
      @media (prefers-color-scheme: dark) {
        body {
          /* Setting it early for background during load */
          --bg-color: #202020;
          --fg-color: #ffffff;
        }
      }
      html,
      body {
        width: 100%;
        height: 100%;
        margin: 0;
      }
      body {
        display: grid;
        background-color: var(--bg-color);
        background-image: var(--bg-img);
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      #vue-app:has(#loading-logo) {
        display: contents;
        color: var(--fg-color);
        & #loading-logo {
          place-self: center;
          font-size: clamp(2px, 1vw, 6px);
          line-height: 1;
          overflow: hidden;
          max-width: 100vw;
          border-radius: 20ch;
        }
      }
      .visually-hidden {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip-path: inset(50%);
        white-space: nowrap;
        border: 0;
      }
    </style>
    <link rel="manifest" href="manifest.json" />
  </head>

  <body class="litegraph grid">
    <div id="vue-app">
      <span class="visually-hidden" role="status">Loading ComfyUI...</span>
      <svg
        width="520"
        height="520"
        viewBox="0 0 520 520"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        id="loading-logo"
      >
        <mask
          id="mask0_227_285"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="520"
          height="520"
        >
          <path
            d="M0 184.335C0 119.812 0 87.5502 12.5571 62.9055C23.6026 41.2274 41.2274 23.6026 62.9055 12.5571C87.5502 0 119.812 0 184.335 0H335.665C400.188 0 432.45 0 457.094 12.5571C478.773 23.6026 496.397 41.2274 507.443 62.9055C520 87.5502 520 119.812 520 184.335V335.665C520 400.188 520 432.45 507.443 457.094C496.397 478.773 478.773 496.397 457.094 507.443C432.45 520 400.188 520 335.665 520H184.335C119.812 520 87.5502 520 62.9055 507.443C41.2274 496.397 23.6026 478.773 12.5571 457.094C0 432.45 0 400.188 0 335.665V184.335Z"
            fill="#EEFF30"
          />
        </mask>
        <g mask="url(#mask0_227_285)">
          <rect y="0.751831" width="520" height="520" fill="#172DD7" />
          <path
            d="M176.484 428.831C168.649 428.831 162.327 425.919 158.204 420.412C153.966 414.755 152.861 406.857 155.171 398.749L164.447 366.178C165.187 363.585 164.672 360.794 163.059 358.636C161.446 356.483 158.921 355.216 156.241 355.216H129.571C121.731 355.216 115.409 352.308 111.289 346.802C107.051 341.14 105.946 333.242 108.258 325.134L140.124 213.748L143.642 201.51C148.371 184.904 165.62 171.407 182.097 171.407H214.009C217.817 171.407 221.167 168.868 222.215 165.183L232.769 128.135C237.494 111.545 254.742 98.048 271.219 98.048L339.468 97.9264L389.431 97.9221C397.268 97.9221 403.59 100.831 407.711 106.337C411.949 111.994 413.054 119.892 410.744 128L396.457 178.164C391.734 194.75 374.485 208.242 358.009 208.242L289.607 208.372H257.706C253.902 208.372 250.557 210.907 249.502 214.588L222.903 307.495C222.159 310.093 222.673 312.892 224.291 315.049C225.904 317.202 228.428 318.469 231.107 318.469C231.113 318.469 276.307 318.381 276.307 318.381H326.122C333.959 318.381 340.281 321.29 344.402 326.796C348.639 332.457 349.744 340.355 347.433 348.463L333.146 398.619C328.423 415.209 311.174 428.701 294.698 428.701L226.299 428.831H176.484Z"
            fill="#F0FF41"
          />
        </g>
      </svg>
    </div>
    <script type="module" src="src/main.ts"></script>
  </body>
</html>
